// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__sozsQ","swiper":"Partners_swiper__aPKYt","slide":"Partners_slide__AraKx","image":"Partners_image__P6ScS"};